module.exports = {"menu":{"home":"Inicio","starship":"Nave","profile":"Perfil","ranking":"Ranking","settings":"Ajustes"},"landing":{"spaceship-travel":"Viaja a tu nave"},"profile":{"change-language":"Cambiar idioma","change-language-en":"Cambiar idioma a Inglés","change-language-es":"Cambiar idioma a Español","change-language-kr":"Cambiar idioma a Coreano"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/es.json
// module id = 7ucu
// module chunks = 0